<template>
   <div class="bg-rectangle-card text-center p-1" 
         :style="{'background-color': rectangleCard.bg_color , 'color': rectangleCard.text_color}" 
         :title=" rectangleCard.name + ' (' + rectangleCard.id + ')' "
         >
      <b>{{rectangleCard.capitals}}</b>
   </div>
</template>

<script>
export default {
   props: {
      rectangleCard: Object
   },
}
</script>

<style scoped>
.bg-rectangle-card {
   width: 23px;
   height: 28px;
   font-size: 12px;
}
</style>